// extracted by mini-css-extract-plugin
module.exports = {"title":"clones-module__title___MDTbL","content":"clones-module__content___3oIk5"};